module.exports = __webpack_public_path__ + "static/canary-island-0-1b92958c2a0eddac014f2fc4ceae4b19.png";